<template>
    <div class="mt-0" align="center">
  
    </div>
  </template>
  <script>
  import axios from 'axios'
  import { shopService_dotnet } from '@/website/global'
  import Swal from 'sweetalert2';
  import { token_api } from '@/website/backend/token'
  import { AlertSuccess, AlertWarning, AlertError } from "@/website/global_alert";
  import { load_languages } from '@/website/global_function'
    export default {
      components: {
      },
      data: () => ({
        use_language: {},
        set_language: null,
      }),
      async created () {
        this.set_language = localStorage.getItem("set_language") || "TH";
        this.use_language = (await this.load_languages())[this.set_language];
        let params = new URL(document.location).searchParams
        let verifycallback = params.get("ref")

        if(verifycallback != null){
          await this.verifyEmailcallback(verifycallback)
        }else {
            Swal.fire({
            toast: true,
            timer: 3000,
            position: 'top',
            type: 'error',
            title: this.use_language.verify_code_not_found,
            showConfirmButton: false,
            })
            this.$router.push('/loginOasys')
        }
      },
      methods: {
        async verifyEmailcallback(verifycallback) {
          let response1 = await axios.post(shopService_dotnet+'Register/register-by-email',{
                verifyCode:verifycallback
          } , {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api })
          if(response1.data.status === "success")
          {
            this.$swal({
                type: 'success',
                title: this.use_language.registered_successfully,
                text: this.use_language.press_confirm_to_login,
                confirmButtonText: this.use_language.confirm,
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false
                }).then(async (result) => {
                if (result.value) {
                    this.$router.push('/loginOasys')
                }
                })
          }
          else{
            Swal.fire({
                toast: true,
                timer: 3000,
                position: 'top',
                type: 'warning',
                title: response1.data.message.th,  //hardcode เป็นภาษาไทยก่อน
                showConfirmButton: false,

            })
          this.$router.push('/loginOasys')
          }

        },
    AlertSuccess,
    AlertWarning,
    AlertError,
    load_languages,
      },
    }
  </script>
  